var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NuxtImg',{class:_vm.size && `ucrs-logo--${_vm.size}`,attrs:{"src":`/assets/img/logo/${_vm.logo.img}`,"alt":"Logo UniCredit RE Services","width":_vm.logo.width,"height":_vm.logo.height,"format":"webp","loading":!_vm.preload ? 'lazy' : null}})
}
var staticRenderFns = []

export { render, staticRenderFns }